import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import translations from "./translations";

const STORAGE_KEY = "ec_lang";
const SUPPORTED = ["en", "gr"];
const DEFAULT_LANG = "gr";

const LanguageContext = createContext({
  lang: DEFAULT_LANG,
  setLang: () => {},
  t: (k) => k,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const stored = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED.includes(stored) ? stored : DEFAULT_LANG;
  });

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang === "gr" ? "el" : "en";
    }
  }, [lang]);

  const setLang = (next) => {
    if (!SUPPORTED.includes(next)) return;
    localStorage.setItem(STORAGE_KEY, next);
    setLangState(next);
  };

  const t = useMemo(() => {
    const dict = translations[lang] || translations[DEFAULT_LANG];
    const fallback = translations[DEFAULT_LANG];
    return (key) => (dict[key] !== undefined ? dict[key] : fallback[key] ?? key);
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  return useContext(LanguageContext);
}
